import { Component, OnChanges, ChangeDetectionStrategy, input, output, linkedSignal } from '@angular/core';
import {EncompassTreeNode} from '../../model/encompass-tree-node';
import {DocumentationNodeComponent} from '../documentation-node/documentation-node.component';

import {MatIcon} from '@angular/material/icon';

@Component({
    selector: 'app-documentation-tree',
    templateUrl: './documentation-tree.component.html',
    styleUrls: ['./documentation-tree.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, DocumentationNodeComponent]
})
export class DocumentationTreeComponent implements OnChanges {

  readonly expandedInput = input.required<boolean>({ alias: 'expanded' });
  readonly expanded = linkedSignal(() => this.expandedInput());
  readonly nodes = input.required<EncompassTreeNode[]>();
  readonly selectedCategory = input<string>(undefined!);
  readonly sharingAllowed = input<boolean>(undefined!);
  readonly downloadRequested = output<EncompassTreeNode>();
  readonly shareRequested = output<EncompassTreeNode>();
  title!: string;
  children!: EncompassTreeNode[];

  downloadFile(node: EncompassTreeNode): void {
    this.downloadRequested.emit(node);
  }

  shareFile(node: EncompassTreeNode): void {
    this.shareRequested.emit(node);
  }

  ngOnChanges(): void {
    if ((this.nodes()?.length || 0) > 0) {
      this.title = this.nodes()[0].displayName;
      this.children = this.nodes()[0].children;
    }
  }

  toggleExpansion(): void {
    this.expanded.update(value => !value);
  }

}
